import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { preprocessTripObject } from 'app/utils/trip';
import { getActiveLanguage } from 'app/sagas/selectors';

import {
  BOOK_TRIP_FORM,
  PRICE_FIELD_NAME,
  DEPARTING_TRIP_FIELD_NAME,
} from 'app/constants';

const selector = formValueSelector(BOOK_TRIP_FORM);

const mapStateToProps = (state) => {
  const trip = selector(state, DEPARTING_TRIP_FIELD_NAME);
  const priceField = selector(state, PRICE_FIELD_NAME);
  const activeLanguage = getActiveLanguage(state);

  if (!trip) {
    return {
      priceUpdating: true,
    };
  }

  const preparedTrip = preprocessTripObject(trip);
  const { onDemand, areTermsInternal, termsOfServiceURL } =
    preparedTrip.details;
  const pricing = preparedTrip.pricing;
  const price = priceField && (priceField.finalPrice || pricing.price);
  const priceUpdating =
    !priceField ||
    priceField.updating === true ||
    priceField.updating === undefined;

  return {
    price,
    priceUpdating,
    onDemand,
    areTermsInternal,
    termsOfServiceURL,
    activeLanguage,
  };
};

export const builder = (ComposedComponent) =>
  connect(mapStateToProps)(ComposedComponent);

export default builder;
